import styled from "styled-components";

export const ServiceMain = styled.section`
  margin: 0 auto;
  padding: 5rem 0 0;
  text-align: center;
  max-width: 966px;
  overflow: hidden;

  postion: relative;
  &.no_padding {
    padding: 0;
  }

  .header {
    align-content: center;
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 10px;
    height: min-content;
    justify-content: center;
    overflow: hidden;
    padding: 28px;
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .empty {
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 10px;
    height: 127px;
    justify-content: center;
    max-width: 966px;
    overflow: hidden;
    padding: 71px;
    position: relative;
    width: 100%;
    border-right: 1px solid rgb(31, 31, 31);
    border-bottom: 1px solid rgb(31, 31, 31);
    border-left: 1px solid rgb(31, 31, 31);
  }
  .box_header {
    align-content: center;
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0px 0px;
    height: 100%;
    justify-content: center;
    left: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;

    border-top: 1px solid rgb(31, 31, 31);
    border-bottom: 1px solid rgb(31, 31, 31);
    border-left: 1px solid rgb(31, 31, 31);
  }

  .box {
    flex: 1 0 0px;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 1px;
    border-right: 1px solid rgb(31, 31, 31);
  }
  .header_text {
    font-size: 56px;
  }

  @media (max-width: 600px) {
    margin: 0rem auto 0 auto;

    > h2 {
      font-size: 25px;
      line-height: 35px;
      width: 90%;
    }

    > p {
      padding: 0 5%;
    }
  }
  @media (max-width: 450px) {
  }
  @media (max-width: 400px) {
    .header_text {
      font-size: 36px;
      line-height: 1.2em;
    }
  }
`;

export const FlexedData = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 48px;
  position: relative;
  width: 100%;

  border-bottom: 1px solid rgb(31, 31, 31);
  border-left: 1px solid rgb(31, 31, 31);
  border-right: 1px solid rgb(31, 31, 31);

  > section {
    align-content: center;
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 84px 24px;
    height: min-content;
    justify-content: center;
    overflow: visible;
    padding: 0;
    position: relative;
    width: 100%;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 50px;
    margin: 0;
    width: 100%;
    text-align: center;
    padding: 48px 0;

    > section {
      width: 95%;
      padding: 0 1%;
      text-align: center;
    }
  }
  @media (max-width: 728px) {
    > section {
      flex-flow: column-reverse;
    }
  }
  @media (max-width: 450px) {
  > section {
      gap:32px
    }
    
  }
`;

export const CardSection = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 32px;
  height: min-content;
  justify-content: center;
  padding: 0;
  position: relative;
  text-align: left;
  width: 1px;
  h3 {
    font-size: 40px;
    margin: 0px;
    line-height: 0.9em;
  }
  p {
    font-size: 18px;
    margin: 0px;
    color: rgb(161, 161, 161);
  }

  .img_container {
    width: 100%;
    heigh: 100%;
    background: rgb(11, 11, 11);
    height: 423px;
    position: relative;
    overflow: hidden;

    background-image: url("/images/image.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 0 100%;
    border: 1px solid rgb(31, 31, 31);
  }

  .hero3 {
    overflow: hidden;
    height: 100%;
    width: 100%;
    > img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 728px) {
    margin: 0;
    h3 {
      line-height: 1.2em;
    }
    img {
      width: 100%;
    }
  }
  @media (max-width: 728px) {
    flex: 1;
    width: 100%;
  }

  @media (max-width: 450px) {
  gap:10px;
    h3 {
      font-size: 24px;
    }
      p{
      font-size:16px;}
  }
`;

export const ItemCard = styled.div`
  background: #f1e4ff;
  padding: 0.2rem 5% 2rem 5%;
  display: flex;
  align-items: Center;
  gap: 40px;

  > div {
    width: 80%;
  }

  img {
    width: 5.5rem;
  }

  h4 {
    font-weight: 700;
    font-size: 22px;
    letter-spacing: 0.15px;
  }

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.15px;
    line-height: 30px;
    color: #000000;
  }

  @media (max-width: 728px) {
    width: 100%;
    gap: 40px 15px;

    > div {
      width: 70%;
    }
  }
`;
